import { Injectable } from '@angular/core';
import { WpAjaxService } from '../wp-ajax/wp-ajax.service';
import { Observable } from 'rxjs/Observable';
import { VehicleFilterResult } from '../../../api/models/vehicle-filter-result';
import { VehicleItem, VehicleClass } from '../../../api/models/vehicle-item';
import { CookieHelperService } from '../cookie-helper.service';
import { SessionHelperService } from '../session-helper.service';

@Injectable()
export class VehicleService {

    private SelectedVehicle: VehicleItem;
    constructor(
        private http: WpAjaxService,
        private sessionService: SessionHelperService,
        private cookieService: CookieHelperService) { }

    getByFilter(filters): Observable<VehicleFilterResult> {
        const postData = {
            request_type: 'getVehicles',
        };

        return this.http.post_request(postData).map((response: VehicleFilterResult) => response);
    }

    getVehicleDetail(inventoryId: string): Observable<VehicleItem> {
        const postData = {
            request_type: 'getVehicleDetail',
            inventoryID: inventoryId
        };
        return this.http.post_request(postData).map((response) => response.data);
    }

    setVehicle (vehicle: VehicleItem, sessionGUID: string = null) {
        this.SelectedVehicle = vehicle;

        if (this.SelectedVehicle === null || this.SelectedVehicle === undefined) {
            this.SelectedVehicle = null;
            return;
        }

        let vehicleClass = VehicleClass.Unset;

        if (vehicle.VehicleClass.toString() !== '') {
            vehicleClass = parseFloat(vehicle.VehicleClass.toString());
        }

        if (vehicleClass === VehicleClass.Unset) {
            vehicleClass = vehicle.BasicInfo.Condition.toLowerCase() === 'new' ? VehicleClass.New : VehicleClass.Used;
        }

        // this.cookieService._setCookie('VehicleDetails', JSON.stringify(<VehicleItem> {
        //     VehicleClass: vehicleClass,
        //     BasicInfo: vehicle.BasicInfo,
        //     DealerInfo: vehicle.DealerInfo,
        //     PaymentInfo: vehicle.PaymentInfo,
        //     InventoryId: vehicle.InventoryId,
        //     DCInventoryID: vehicle.DCInventoryID,
        //     MainThumbnailUrl: vehicle.MainThumbnailUrl,
        //     WestlakeClassCode: vehicle.WestlakeClassCode,
        // }));
        const DealerInfo = vehicle.DealerInfo;
        DealerInfo.DealerPhoneNumber = DealerInfo.DealerPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

        this.sessionService.setSession('VehicleDetails', <VehicleItem> {
            DealerInfo,
            VehicleClass: vehicleClass,
            BPDealerInfo: vehicle.BPDealerInfo,
            BasicInfo: vehicle.BasicInfo,
            PaymentInfo: vehicle.PaymentInfo,
            InventoryId: vehicle.InventoryId,
            DCInventoryID: vehicle.DCInventoryID,
            MainThumbnailUrl: vehicle.MainThumbnailUrl,
            WestlakeClassCode: vehicle.WestlakeClassCode,
        }, sessionGUID).subscribe(res => {});
    }

    getVehicle (sessionGUID: string = null): Observable<VehicleItem> {
        return new Observable<VehicleItem>(observer => {
            this.sessionService.getSession(null, sessionGUID).subscribe(result => {
                const vehicleDetails = result.VehicleDetails;
                if (vehicleDetails !== null && vehicleDetails !== undefined) {
                    if (this.SelectedVehicle === undefined || this.SelectedVehicle === null) {
                        observer.next(vehicleDetails);
                        observer.complete();
                        return;
                    }
                    if (vehicleDetails.InventoryId === this.SelectedVehicle.InventoryId) {
                        observer.next(vehicleDetails);
                        observer.complete();
                        return;
                    }
                }
                observer.next(this.SelectedVehicle === undefined ? null : this.SelectedVehicle);
            } , err => observer.error(err), () => observer.complete());
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/vehicles/vehicle.service.ts